module.exports = __webpack_public_path__ + "static/media/cake-and-old-books.e30fb710.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2020-06-06/cake-and-old-books.jpg
// module id = 825
// module chunks = 0